import React from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import orthopedic from "../assets/orthopedic.jpeg";
import orthoImg1 from "../assets/ortho1.png";
import orthoImg2 from "../assets/ortho2.jpeg";
import orthoImg3 from "../assets/image2.jpeg";
import { ArrowRight } from "lucide-react";

const Orthopedic = () => {
  const services = [
    {
      title: "Orthopedics",
      description:
        "Treatment of common bone and joint conditions such as fractures, arthritis, and sprains.",
      image: orthoImg1,
    },
    {
      title: "Joint Replacement Surgery",
      description:
        "Procedures like knee and hip replacement to relieve chronic joint pain and improve mobility.",
      image: orthoImg2,
    },
    {
      title: "Trauma and Fracture Care",
      description:
        "Emergency and reconstructive treatment for broken bones and severe musculoskeletal injuries.",
      image: orthoImg3,
    },
  ];

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <div
        className="relative h-[500px] bg-cover bg-center"
        style={{ backgroundImage: `url(${orthopedic})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-30" />
      </div>

      {/* Description */}
      <p className="px-12 mt-6 text-xl font-semibold text-center text-gray-800">
        The Orthopedics Department is a medical specialty focused on diagnosing,
        treating, and preventing disorders of the musculoskeletal system. This
        includes bones, joints, muscles, ligaments, tendons, and nerves.
      </p>

      {/* Services Cards */}
      <div className="grid grid-cols-1 gap-6 px-12 py-10 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((service, index) => (
          <div
            key={index}
            className="overflow-hidden transition duration-300 bg-white shadow-md rounded-xl hover:shadow-lg"
          >
            <div className="flex items-center justify-center w-full p-2 bg-white rounded-lg h-60">
              <img
                src={service.image}
                alt={service.title}
                className="object-contain w-full h-full"
              />
            </div>
            <div className="p-4">
              <h3 className="text-lg font-bold text-[#009DA5]">
                {service.title}
              </h3>
              <p className="mt-2 text-gray-600">{service.description}</p>
              <div className="flex justify-end mt-3">
                <ArrowRight className="text-[#009DA5]" />
              </div>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};

export default Orthopedic;
